import { withChartLayout } from 'components/common';
import Therapies from 'components/features/chart/order-entry/therapies/Therapies';

const TherapiesPage = withChartLayout('Therapies')(Therapies);
export default TherapiesPage;
